// // 计算线性回归系数
// function calculateLinearRegression(data) {
//     let n = data.length;
//     let sumX = 0, sumY = 0, sumXY = 0, sumX2 = 0;
    
//     for (let i = 0; i < n; i++) {
//         const x = data[i].CorrectionValue;  // x轴数据
//         const y = data[i].Value;            // y轴数据
        
//         sumX += x;
//         sumY += y;
//         sumXY += x * y;
//         sumX2 += x * x;
//     }
    
//     const denominator = n * sumX2 - sumX * sumX;
//     const a = (n * sumXY - sumX * sumY) / denominator;
//     const b = (sumY - a * sumX) / n;
    
//     return { a, b };
// }

// 准备数据
// function prepareChartData(data, regression) {
//   // 原始散点数据
//   const scatterData = data.map(item => [item.CorrectionValue, item.Value]);

//   // 计算回归线的两个端点
//   // 找出x的最小值和最大值
//   const xValues = data.map(item => item.CorrectionValue);
//   const yValues = data.map(item => item.Value);

//   const xMin_1 = Math.min(...xValues);
//   const xMax_1 = Math.max(...xValues);
//   const yMin_1 = Math.min(...yValues);
//   const yMax_1 = Math.max(...yValues);
  
//   // 生成回归线数据点
//   let lineData = null;

//     if (scatterData.length === 2) {
//         lineData = [...scatterData]
//     } else {
//         lineData = [
//             [xMin_1, regression.a * xMin_1 + regression.b],  // 起点
//             [xMax_1, regression.a * xMax_1 + regression.b ]   // 终点
//         ];
//     }
//     // const lineData = [
//     //       [xMin_1, 90],  // 起点
//     //       [xMax_1, regression.a * 90 + regression.b ]   // 终点
//     //   ];
//     //   const lineData = [
//     //       [yMin_1, regression.a * yMin_1 + regression.b],  // 起点
//     //       [yMax_1, regression.a * yMax_1 + regression.b]   // 终点
//     //   ];

//     debugger
//   const xMin = Math.min(...scatterData.concat(lineData).map(item => item[0]))
//   const xMax = Math.max(...scatterData.concat(lineData).map(item => item[0]))
//   const yMin = Math.min(...scatterData.concat(lineData).map(item => item[1]))
//   const yMax = Math.max(...scatterData.concat(lineData).map(item => item[1]))
  
//   return { scatterData, lineData, xMin, xMax, yMin, yMax };
// }

const RELAX_FACTOR = 1;
function prepareChartData(data, regression) {
  // 原始散点数据 - 注意这里x轴是CorrectionValue，y轴是Value
  const scatterData = data.map(item => [item.CorrectionValue, item.Value]);
  
  // 找出x的最小值和最大值 (CorrectionValue)
  const xValues = data.map(item => item.CorrectionValue);
  const xMin = Math.min(...xValues);
  const xMax = Math.max(...xValues);
  
  // 计算回归线的两个端点
  // 重要：regression.a 和 regression.b 是基于 (CorrectionValue, Value) 的关系
  // 所以要用 x (CorrectionValue) 来计算 y (Value)

    // 计算回归线上的点：y = a*x + b
    const startY = regression.a * xMin + regression.b;
    const endY = regression.a * xMax + regression.b;

    const lineData = [
      [xMin, startY],  // 起点
      [xMax, endY]     // 终点
    ];
    
    // 添加调试信息
    console.log('回归线计算:', {
      x范围: [xMin, xMax],
      斜率: regression.a,
      截距: regression.b,
      起点: [xMin, startY],
      终点: [xMax, endY]
    });
    
    // 验证每个数据点是否在回归线上
    console.log('数据点验证:');
    data.forEach(item => {
      const predictedY = regression.a * item.CorrectionValue + regression.b;
      console.log(
        `点 (${item.CorrectionValue}, ${item.Value}) -> ` +
        `预测值: ${predictedY.toFixed(2)}, ` +
        `误差: ${(item.Value - predictedY).toFixed(2)}`
      );
    });
  
  // 计算所有点的范围（用于坐标轴）
  const allPoints = [...scatterData, ...lineData];
  const xMin_all = Math.min(...allPoints.map(item => item[0]));
  const xMax_all = Math.max(...allPoints.map(item => item[0]));
  const yMin_all = Math.min(...allPoints.map(item => item[1]));
  const yMax_all = Math.max(...allPoints.map(item => item[1]));
  
  // 添加一些边距，让图表看起来更舒服
  const xPadding = (xMax_all - xMin_all) * 0.1;
  const yPadding = (yMax_all - yMin_all) * 0.1;
  
  return { 
    scatterData, 
    lineData, 
    xMin: Math.floor((xMin_all - xPadding) / 100) * 100, 
    xMax: Math.ceil((xMax_all + xPadding) / 100) * 100, 
    yMin: Math.floor((yMin_all - yPadding) / 100) * 100, 
    yMax: Math.ceil((yMax_all + yPadding) / 100) * 100,
    // 添加回归方程信息
    equation: `y = ${regression.a.toFixed(4)}x + ${regression.b.toFixed(4)}`
  };
}

export function calculateFitScore(data, regression, relaxFactor = RELAX_FACTOR) {
    // 参数验证
    if (!data || data.length < 2) {
        return 0;
    }
    
    const n = data.length;
    
    // 1. 计算R²（决定系数）
    let ssTotal = 0;
    let ssResidual = 0;
    
    const yValues = data.map(item => item.Value);
    const meanY = yValues.reduce((sum, y) => sum + y, 0) / n;
    
    data.forEach(point => {
        const x = point.CorrectionValue;
        const y = point.Value;
        const predictedY = regression.a * x + regression.b;
        
        ssTotal += Math.pow(y - meanY, 2);
        ssResidual += Math.pow(y - predictedY, 2);
    });
    
    const rSquared = ssTotal === 0 ? 0 : 1 - (ssResidual / ssTotal);
    
    // 2. 计算平均相对误差
    let totalRelativeError = 0;
    data.forEach(point => {
        const x = point.CorrectionValue;
        const y = point.Value;
        const predictedY = regression.a * x + regression.b;
        
        if (y !== 0) {
            totalRelativeError += Math.abs((y - predictedY) / y);
        } else {
            totalRelativeError += Math.abs(y - predictedY);
        }
    });
    const avgRelativeError = totalRelativeError / n;
    
    // 3. 计算相关系数
    const xValues = data.map(item => item.CorrectionValue);
    const yVals = data.map(item => item.Value);
    
    const meanX = xValues.reduce((sum, x) => sum + x, 0) / n;
    
    let covariance = 0;
    let varianceX = 0;
    let varianceY = 0;
    
    for (let i = 0; i < n; i++) {
        const dx = xValues[i] - meanX;
        const dy = yVals[i] - meanY;
        covariance += dx * dy;
        varianceX += dx * dx;
        varianceY += dy * dy;
    }
    
    const correlationCoefficient = Math.sqrt(varianceX) * Math.sqrt(varianceY) === 0 ? 
        0 : covariance / (Math.sqrt(varianceX) * Math.sqrt(varianceY));
    
    // 4. 综合评分（权重不变）
    const weights = {
        rSquared: 0.5,
        relativeError: 0.3,
        correlation: 0.2
    };
    
    const rSquaredScore = Math.max(0, rSquared) * 100;
    const errorScore = Math.max(0, 100 - (avgRelativeError * 100));
    const correlationScore = Math.abs(correlationCoefficient) * 100;
    
    // 5. 加权总分
    let totalScore = 
        rSquaredScore * weights.rSquared +
        errorScore * weights.relativeError +
        correlationScore * weights.correlation;
    
    // 6. 数据点数量惩罚（更宽松）
    if (n < 3) {
        // 只有1-2个点时轻微惩罚
        totalScore *= (n / 3) * 0.9;
    } else if (n < 5) {
        // 3-4个点时基本不惩罚
        totalScore *= 0.95;
    }
    // 5个点以上完全没惩罚
    
    // 7. 应用宽松因子（核心！）
    totalScore = Math.min(100, totalScore * relaxFactor);
    
    // 8. 确保不低于20分
    totalScore = Math.max(20, totalScore);
    
    return {
        score: Math.round(totalScore),
        details: {
            rSquared: rSquared,
            avgRelativeError: avgRelativeError,
            correlationCoefficient: correlationCoefficient,
            dataCount: n,
            rawScore: totalScore / relaxFactor,
            relaxFactor: relaxFactor
        }
    };
}
// export function calculateFitScore(data, regression) {
//     // 参数验证
//     if (!data || data.length < 2) {
//         return 0;
//     }
    
//     const n = data.length;
    
//     // 1. 计算R²（决定系数）
//     let ssTotal = 0;
//     let ssResidual = 0;
    
//     // 计算y的平均值
//     const yValues = data.map(item => item.Value);
//     const meanY = yValues.reduce((sum, y) => sum + y, 0) / n;
    
//     // 计算总平方和与残差平方和
//     data.forEach(point => {
//         const x = point.CorrectionValue;
//         const y = point.Value;
//         const predictedY = regression.a * x + regression.b;
        
//         ssTotal += Math.pow(y - meanY, 2);
//         ssResidual += Math.pow(y - predictedY, 2);
//     });
    
//     // 计算R²（决定系数）
//     const rSquared = ssTotal === 0 ? 0 : 1 - (ssResidual / ssTotal);
    
//     // 2. 计算数据点与回归线的平均相对误差
//     let totalRelativeError = 0;
//     data.forEach(point => {
//         const x = point.CorrectionValue;
//         const y = point.Value;
//         const predictedY = regression.a * x + regression.b;
        
//         // 避免除以0
//         if (y !== 0) {
//             totalRelativeError += Math.abs((y - predictedY) / y);
//         } else {
//             totalRelativeError += Math.abs(y - predictedY);
//         }
//     });
//     const avgRelativeError = totalRelativeError / n;
    
//     // 3. 计算数据分布的线性度（通过相关系数）
//     const xValues = data.map(item => item.CorrectionValue);
//     const yVals = data.map(item => item.Value);
    
//     // 计算相关系数
//     const meanX = xValues.reduce((sum, x) => sum + x, 0) / n;
    
//     let covariance = 0;
//     let varianceX = 0;
//     let varianceY = 0;
    
//     for (let i = 0; i < n; i++) {
//         const dx = xValues[i] - meanX;
//         const dy = yVals[i] - meanY;
//         covariance += dx * dy;
//         varianceX += dx * dx;
//         varianceY += dy * dy;
//     }
    
//     const correlationCoefficient = Math.sqrt(varianceX) * Math.sqrt(varianceY) === 0 ? 
//         0 : covariance / (Math.sqrt(varianceX) * Math.sqrt(varianceY));
    
//     // 4. 综合评分（加权计算）
//     const weights = {
//         rSquared: 0.5,          // R²权重最大
//         relativeError: 0.3,     // 相对误差权重次之
//         correlation: 0.2        // 相关系数权重
//     };
    
//     // R²评分（R²越接近1，得分越高）
//     const rSquaredScore = Math.max(0, rSquared) * 100;
    
//     // 相对误差评分（误差越小，得分越高）
//     const errorScore = Math.max(0, 100 - (avgRelativeError * 100));
    
//     // 相关系数评分（越接近1或-1，线性关系越强）
//     const correlationScore = Math.abs(correlationCoefficient) * 100;
    
//     // 5. 加权总分
//     let totalScore = 
//         rSquaredScore * weights.rSquared +
//         errorScore * weights.relativeError +
//         correlationScore * weights.correlation;
    
//     // 6. 数据点数量惩罚（数据点太少会降低可信度）
//     let dataCountPenalty = 1;
//     if (n < 5) {
//         // 数据点少于5个时进行惩罚
//         dataCountPenalty = n / 5;
//     }
    
//     totalScore *= dataCountPenalty;
    
//     // 7. 确保分数在0-100之间
//     totalScore = Math.max(0, Math.min(100, totalScore));
    
//     // 8. 返回结果（包含详细评分）
//     return {
//         score: Math.round(totalScore),
//         details: {
//             rSquared: rSquared,
//             rSquaredScore: Math.round(rSquaredScore),
//             avgRelativeError: avgRelativeError,
//             errorScore: Math.round(errorScore),
//             correlationCoefficient: correlationCoefficient,
//             correlationScore: Math.round(correlationScore),
//             dataCount: n,
//             dataCountPenalty: dataCountPenalty
//         }
//     };
// }

// 先计算回归系数
function calculateLinearRegression(data) {
    let n = data.length;
    let sumX = 0, sumY = 0, sumXY = 0, sumX2 = 0;

    for (let i = 0; i < n; i++) {
        const x = data[i].CorrectionValue;
        const y = data[i].Value;
        
        sumX += x;
        sumY += y;
        sumXY += x * y;
        sumX2 += x * x;
    }
    
    const denominator = n * sumX2 - sumX * sumX;
    const a = (n * sumXY - sumX * sumY) / denominator;
    const b = (sumY - a * sumX) / n;
    
    return { a, b };
}

function calculateLinearFitScore(data) {
    if (!data || data.length < 2) {
        return 0;
    }
    
    // 提取数据
    const x = data.map(item => item.Value);
    const y = data.map(item => item.CorrectionValue);
    
    const n = x.length;
    
    // 计算均值
    const xMean = x.reduce((sum, val) => sum + val, 0) / n;
    const yMean = y.reduce((sum, val) => sum + val, 0) / n;
    
    // 计算SS（离差平方和）
    let ssTotal = 0;  // 总离差平方和
    let ssResidual = 0; // 残差平方和
    
    // 先计算斜率和截距
    let numerator = 0;
    let denominator = 0;
    
    for (let i = 0; i < n; i++) {
        numerator += (x[i] - xMean) * (y[i] - yMean);
        denominator += (x[i] - xMean) * (x[i] - xMean);
    }
    
    if (denominator === 0) return 0;
    
    const slope = numerator / denominator; // 斜率
    const intercept = yMean - slope * xMean; // 截距
    
    // 计算R平方
    for (let i = 0; i < n; i++) {
        const yPredicted = slope * x[i] + intercept;
        ssTotal += Math.pow(y[i] - yMean, 2);
        ssResidual += Math.pow(y[i] - yPredicted, 2);
    }
    
    if (ssTotal === 0) return 100;
    
    const rSquared = 1 - (ssResidual / ssTotal);
    
    // R平方转换为1-100分（R平方本身就是0-1，乘以100即可）
    const score = Math.max(0, Math.min(100, rSquared * 100));
    
    return {
        score: Math.round(score),
        rSquared: rSquared,
        slope: slope,
        intercept: intercept,
        equation: `y = ${slope.toFixed(4)}x + ${intercept.toFixed(4)}`
    };
};

// =========分界线=========

// 基于现有数据和新x值，推荐最优y值来提高拟合度得分
function recommendOptimalY(existingData, newX, options = {}) {
    const {
        yRange = null,           // y值的可选范围 [min, max]
        step = 1,               // 搜索步长
        maxIterations = 1000,   // 最大迭代次数
        includeDetails = false, // 是否包含详细分析
        algorithm = 'balanced'  // 'balanced'平衡搜索, 'quick'快速搜索, 'exhaustive'穷举搜索
    } = options;
    
    // 输入验证
    if (!Array.isArray(existingData) || existingData.length === 0) {
        return {
            recommendedY: newX, // 默认返回x值本身
            score: 0,
            warning: "没有历史数据，无法进行有效推荐"
        };
    }
    
    if (typeof newX !== 'number' || isNaN(newX)) {
        return {
            recommendedY: 0,
            score: 0,
            error: "无效的x值输入"
        };
    }
    
    // 1. 计算当前数据的拟合度作为基准
    const currentRegression = calculateLinearRegression(existingData);
    const currentScore = existingData.length >= 2 ? 
        calculateFitScore(existingData, currentRegression).score : 0;
    
    // 2. 基于历史数据的初步预测
    const basePrediction = predictYFromExisting(existingData, newX);
    
    // 3. 确定搜索范围
    const searchRange = determineSearchRange(existingData, newX, basePrediction, yRange);
    
    // 4. 搜索最优y值
    const bestResult = searchOptimalY(
        existingData, 
        newX, 
        searchRange, 
        step, 
        maxIterations, 
        algorithm
    );
    
    // 5. 准备返回结果
    const result = {
        recommendedY: bestResult.y,
        score: bestResult.score,
        basePrediction: Math.round(basePrediction * 100) / 100,
        scoreImprovement: Math.round((bestResult.score - currentScore) * 100) / 100,
        currentScore: currentScore,
        searchRange: {
            min: Math.round(searchRange.min * 100) / 100,
            max: Math.round(searchRange.max * 100) / 100
        }
    };
    
    // 6. 如果包含详细分析
    if (includeDetails) {
        result.details = {
            algorithm: algorithm,
            iterations: bestResult.iterations,
            candidatesEvaluated: bestResult.candidatesEvaluated,
            convergence: bestResult.convergence
        };
        
        // 提供其他备选方案
        result.alternatives = getAlternativeRecommendations(
            existingData, 
            newX, 
            basePrediction, 
            bestResult.y
        );
    }
    
    // 7. 添加警告信息（如果适用）
    if (existingData.length < 3) {
        result.warning = `历史数据较少（${existingData.length}个点），推荐结果仅供参考`;
    }
    
    if (bestResult.score - currentScore < 5) {
        result.note = "新数据点对整体拟合度提升有限";
    }
    
    return result;
}

// 辅助函数：基于现有数据预测y值
function predictYFromExisting(data, x) {
    if (data.length === 0) return x;
    
    if (data.length === 1) {
        // 只有一个点时，使用比例关系
        const point = data[0];
        return (point.Value / point.CorrectionValue) * x;
    }
    
    // 两个点以上使用线性回归
    const regression = calculateLinearRegression(data);
    return regression.a * x + regression.b;
}

// 辅助函数：确定搜索范围
function determineSearchRange(existingData, newX, basePrediction, userRange) {
    // 如果用户指定了范围，优先使用
    if (userRange && Array.isArray(userRange) && userRange.length === 2) {
        return {
            min: Math.min(userRange[0], userRange[1]),
            max: Math.max(userRange[0], userRange[1])
        };
    }
    
    let minY, maxY;
    
    // 基于历史数据的统计特性
    if (existingData.length >= 2) {
        const yValues = existingData.map(p => p.Value);
        const yMean = yValues.reduce((a, b) => a + b) / yValues.length;
        const yStd = calculateStandardDeviation(yValues);
        
        // 使用预测值±2.5个标准差作为范围
        const stdRange = 2.5;
        minY = basePrediction - stdRange * yStd;
        maxY = basePrediction + stdRange * yStd;
        
        // 确保范围在历史数据范围内扩大一些
        const historicalMin = Math.min(...yValues);
        const historicalMax = Math.max(...yValues);
        const historicalRange = historicalMax - historicalMin;
        
        minY = Math.min(minY, historicalMin - 0.2 * historicalRange);
        maxY = Math.max(maxY, historicalMax + 0.2 * historicalRange);
    } else if (existingData.length === 1) {
        // 只有一个历史点时
        const point = existingData[0];
        const ratio = point.Value / point.CorrectionValue;
        const rangeFactor = 0.3; // ±30%
        minY = basePrediction * (1 - rangeFactor);
        maxY = basePrediction * (1 + rangeFactor);
    } else {
        // 没有历史数据（理论上不会进入这里）
        const rangeFactor = 0.5;
        minY = x * (1 - rangeFactor);
        maxY = x * (1 + rangeFactor);
    }
    
    // 确保最小值为正数（如果数据都是正数的话）
    const allPositive = existingData.every(p => p.Value > 0);
    if (allPositive) {
        minY = Math.max(0.1, minY);
    }
    
    // 确保范围有效
    if (minY >= maxY) {
        maxY = minY + 10;
    }
    
    // 确保范围不会太小
    const minRange = 5;
    if (maxY - minY < minRange) {
        const mid = (minY + maxY) / 2;
        minY = mid - minRange / 2;
        maxY = mid + minRange / 2;
    }
    
    return { min: minY, max: maxY };
}

// 辅助函数：计算标准差
function calculateStandardDeviation(values) {
    if (values.length < 2) return 0;
    
    const mean = values.reduce((a, b) => a + b) / values.length;
    const squareDiffs = values.map(value => {
        const diff = value - mean;
        return diff * diff;
    });
    
    const variance = squareDiffs.reduce((a, b) => a + b) / values.length;
    return Math.sqrt(variance);
}

// 辅助函数：搜索最优y值
function searchOptimalY(existingData, newX, range, step, maxIterations, algorithm) {
    const { min, max } = range;
    
    // 根据算法选择搜索策略
    switch (algorithm) {
        case 'quick':
            return quickSearch(existingData, newX, min, max, maxIterations);
        case 'exhaustive':
            return exhaustiveSearch(existingData, newX, min, max, step);
        case 'balanced':
        default:
            return balancedSearch(existingData, newX, min, max, step, maxIterations);
    }
}

// 快速搜索（使用梯度上升法）
function quickSearch(existingData, newX, min, max, maxIterations) {
    let currentY = (min + max) / 2;
    let bestY = currentY;
    let bestScore = 0;
    let iterations = 0;
    const candidatesEvaluated = [];
    
    // 评估初始点
    const initialScore = evaluateY(existingData, newX, currentY);
    bestScore = initialScore.score;
    candidatesEvaluated.push({ y: currentY, score: initialScore.score });
    
    // 尝试几个关键点
    const testPoints = [
        min,
        max,
        (min * 0.25 + max * 0.75),
        (min * 0.75 + max * 0.25),
        (min + max) / 2
    ];
    
    for (const y of testPoints) {
        if (iterations >= maxIterations) break;
        
        const result = evaluateY(existingData, newX, y);
        iterations++;
        candidatesEvaluated.push({ y: y, score: result.score });
        
        if (result.score > bestScore) {
            bestScore = result.score;
            bestY = y;
        }
    }
    
    // 在最佳点附近进行局部搜索
    const searchStep = (max - min) / 20;
    let localBestY = bestY;
    let localBestScore = bestScore;
    
    for (let offset = -searchStep * 5; offset <= searchStep * 5; offset += searchStep) {
        if (iterations >= maxIterations) break;
        
        const y = bestY + offset;
        if (y < min || y > max) continue;
        
        const result = evaluateY(existingData, newX, y);
        iterations++;
        candidatesEvaluated.push({ y: y, score: result.score });
        
        if (result.score > localBestScore) {
            localBestScore = result.score;
            localBestY = y;
        }
    }
    
    return {
        y: Math.round(localBestY * 100) / 100,
        score: Math.round(localBestScore),
        iterations: iterations,
        candidatesEvaluated: candidatesEvaluated.length,
        convergence: 'quick'
    };
}

// 平衡搜索（混合策略）
function balancedSearch(existingData, newX, min, max, step, maxIterations) {
    // 1. 先进行粗粒度搜索
    const coarseStep = Math.max(step, (max - min) / 50);
    let bestY = min;
    let bestScore = 0;
    let iterations = 0;
    
    // 粗搜索
    for (let y = min; y <= max && iterations < maxIterations / 2; y += coarseStep) {
        const result = evaluateY(existingData, newX, y);
        iterations++;
        
        if (result.score > bestScore) {
            bestScore = result.score;
            bestY = y;
        }
    }
    
    // 2. 在最佳点附近进行细粒度搜索
    const fineMin = Math.max(min, bestY - coarseStep * 3);
    const fineMax = Math.min(max, bestY + coarseStep * 3);
    const fineStep = Math.min(step, coarseStep / 10);
    
    let fineBestY = bestY;
    let fineBestScore = bestScore;
    
    for (let y = fineMin; y <= fineMax && iterations < maxIterations; y += fineStep) {
        const result = evaluateY(existingData, newX, y);
        iterations++;
        
        if (result.score > fineBestScore) {
            fineBestScore = result.score;
            fineBestY = y;
        }
    }
    
    return {
        y: Math.round(fineBestY * 100) / 100,
        score: Math.round(fineBestScore),
        iterations: iterations,
        candidatesEvaluated: Math.floor((max - min) / coarseStep) + Math.floor((fineMax - fineMin) / fineStep),
        convergence: 'balanced'
    };
}

// 穷举搜索（精确但可能慢）
function exhaustiveSearch(existingData, newX, min, max, step) {
    let bestY = min;
    let bestScore = 0;
    let iterations = 0;
    
    for (let y = min; y <= max; y += step) {
        const result = evaluateY(existingData, newX, y);
        iterations++;
        
        if (result.score > bestScore) {
            bestScore = result.score;
            bestY = y;
        }
    }
    
    return {
        y: Math.round(bestY * 100) / 100,
        score: Math.round(bestScore),
        iterations: iterations,
        candidatesEvaluated: iterations,
        convergence: 'complete'
    };
}

// 辅助函数：评估特定y值的拟合度
function evaluateY(existingData, newX, y) {
    const newData = [...existingData, { CorrectionValue: newX, Value: y }];
    const regression = calculateLinearRegression(newData);
    return calculateFitScore(newData, regression);
}

// 辅助函数：获取备选推荐方案
function getAlternativeRecommendations(existingData, newX, basePrediction, optimalY) {
    const alternatives = [];
    
    // 备选1：线性回归预测值
    alternatives.push({
        y: Math.round(basePrediction * 100) / 100,
        type: 'linear_prediction',
        description: '基于历史数据的线性回归预测'
    });
    
    // 备选2：保持最近趋势
    if (existingData.length >= 2) {
        const lastTwo = existingData.slice(-2);
        const slope = (lastTwo[1].Value - lastTwo[0].Value) / 
                     (lastTwo[1].CorrectionValue - lastTwo[0].CorrectionValue);
        const trendY = lastTwo[1].Value + slope * (newX - lastTwo[1].CorrectionValue);
        
        alternatives.push({
            y: Math.round(trendY * 100) / 100,
            type: 'trend_continuation',
            description: '延续最近两个点的趋势'
        });
    }
    
    // 备选3：取中间值（如果最优值比较极端）
    if (Math.abs(optimalY - basePrediction) > Math.abs(basePrediction * 0.2)) {
        const middleY = (optimalY + basePrediction) / 2;
        alternatives.push({
            y: Math.round(middleY * 100) / 100,
            type: 'compromise',
            description: '最优值和预测值的折中'
        });
    }
    
    // 评估每个备选方案的分数
    alternatives.forEach(alt => {
        const newData = [...existingData, { CorrectionValue: newX, Value: alt.y }];
        const regression = calculateLinearRegression(newData);
        alt.score = calculateFitScore(newData, regression).score;
    });
    
    // 按分数排序
    alternatives.sort((a, b) => b.score - a.score);
    
    return alternatives;
}

// 简化使用函数（快速获取推荐）
export function quickRecommendY(existingData, newX) {
    return recommendOptimalY(existingData, newX, {
        algorithm: 'quick',
        includeDetails: false
    });
}

// 批量推荐函数（一次推荐多个x值）
export function batchRecommendY(existingData, newXArray, options = {}) {
    const results = [];
    
    for (const newX of newXArray) {
        const recommendation = recommendOptimalY(existingData, newX, options);
        results.push({
            x: newX,
            ...recommendation
        });
    }
    
    // 分析整体趋势
    const overallAnalysis = analyzeBatchResults(results);
    
    return {
        recommendations: results,
        analysis: overallAnalysis
    };
}

// 分析批量结果
function analyzeBatchResults(results) {
    if (results.length === 0) return null;
    
    const scores = results.map(r => r.score);
    const improvements = results.map(r => r.scoreImprovement);
    
    return {
        averageScore: scores.reduce((a, b) => a + b, 0) / scores.length,
        averageImprovement: improvements.reduce((a, b) => a + b, 0) / improvements.length,
        maxScore: Math.max(...scores),
        minScore: Math.min(...scores),
        consistency: calculateConsistency(results)
    };
}

// 计算推荐的一致性
function calculateConsistency(results) {
    if (results.length < 2) return 1;
    
    // 检查推荐值是否形成线性关系
    const points = results.map(r => ({ x: r.x, y: r.recommendedY }));
    const regression = calculateLinearRegression(points.map(p => ({ 
        CorrectionValue: p.x, 
        Value: p.y 
    })));
    
    const rSquared = calculateRSquared(points, regression);
    return Math.round(rSquared * 100) / 100;
}

// 计算R²
function calculateRSquared(points, regression) {
    const yValues = points.map(p => p.y);
    const meanY = yValues.reduce((a, b) => a + b, 0) / yValues.length;
    
    let ssTotal = 0;
    let ssResidual = 0;
    
    points.forEach(point => {
        const predictedY = regression.a * point.x + regression.b;
        ssTotal += Math.pow(point.y - meanY, 2);
        ssResidual += Math.pow(point.y - predictedY, 2);
    });
    
    return ssTotal === 0 ? 1 : 1 - (ssResidual / ssTotal);
}

// 使用示例
/*
const existingData = [
    { Value: 90, CorrectionValue: 89 },
    { Value: 94, CorrectionValue: 90 },
    { Value: 96, CorrectionValue: 94 },
    { Value: 101, CorrectionValue: 98 },
    { Value: 105, CorrectionValue: 102 }
];

// 单个推荐
const recommendation = recommendOptimalY(existingData, 100, {
    yRange: [95, 110],
    step: 0.1,
    includeDetails: true
});

console.log('推荐结果:', recommendation);

// 快速推荐
const quickRec = quickRecommendY(existingData, 100);
console.log('快速推荐:', quickRec);

// 批量推荐
const batchRec = batchRecommendY(existingData, [95, 100, 105]);
console.log('批量推荐:', batchRec);
*/

export { calculateLinearFitScore, calculateLinearRegression, prepareChartData, recommendOptimalY, RELAX_FACTOR };